module.exports = "<div class=\"ui-card padding-md\">\r\n  <div class=\"kd-item kd-item--large typo-title\">\r\n    Sucursales\r\n  </div>\r\n</div>\r\n<contabilidad-catalogosexternos-sucursales-lista></contabilidad-catalogosexternos-sucursales-lista>";


//////////////////
// WEBPACK FOOTER
// ./src/contabilidad/catalogosexternos/components/sucursales/template.html
// module id = 1711
// module chunks = 0